import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { APP_VERSION, BUILD_INFO } from "../utils/version";

const useStyles = makeStyles(() => ({
  version: {
    fontSize: 11,
    textAlign: "center",
    margin: 0,
    padding: "12px 0",
    userSelect: "text",
  },
}));

// Version of the platform (the git tag it was built from). Hover shows branch@commit.
// pinToBottom: stuck to the bottom edge of the window over a `width` px wide strip (the side menu), so it is always visible
const VersionLabel = ({ color = "#9a9a9a", className, pinToBottom = false, width = 300, background = "#000" }) => {
  const classes = useStyles();
  const pinned = pinToBottom
    ? { position: "fixed", bottom: 0, left: 0, width, background, zIndex: 1 }
    : {};
  return (
    <p
      className={[classes.version, className].filter(Boolean).join(" ")}
      style={{ color, ...pinned }}
      title={BUILD_INFO || undefined}
      data-testid="app-version"
    >
      {APP_VERSION}
    </p>
  );
};

export default VersionLabel;
